import TextField from '@mui/material/TextField';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import dayjs from 'dayjs';

export default function YearPicker({ value, onChange }) {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ko">
      <DatePicker
        label="년도 선택"
        views={['year']}        
        value={value}
        onChange={onChange}
        inputFormat={dayjs(value).format("YYYY")}
        renderInput={(params) => 
          <TextField
            {...params}
            inputProps={{
              ...params.inputProps,
              readOnly: true
            }}
          />
        }
      />
    </LocalizationProvider>
  );
}
